import { getMessagesControl } from 'providers/Toast';

export const MESSAGES = getMessagesControl({
  excelError: (t) => ({
    title: t('excel-download-error'),
    type: 'error',
  }),

  excelNotDownloaded: (t) => ({
    title: t('some-invoices-were-not-downloaded'),
    type: 'error',
  }),
});
